import { NgModule } from '@angular/core';
import { TyaNumberVNInputDirective } from './convert-number-vn.directive';

@NgModule({
  imports: [],
  declarations: [TyaNumberVNInputDirective],
  exports: [TyaNumberVNInputDirective]
})
export class TyaDirectivesModule { }
